var exports = {
  "az": "Box__LP876q",
  "wy": "Box_1__vhw1eQ",
  "N_": "Link__NUA-4Y",
};

module.exports = exports;
